module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/asset/copyUrl.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/asset/copyUrl.png
// module id = 863
// module chunks = 418